import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { UserContext, useAuthorization, useRuntime } from '../../shell';
export function UserContextProvider({ children }) {
    const runtime = useRuntime();
    const { setAuthorizationScopeId } = useAuthorization();
    const [username, setUsername] = useState(runtime.getSession().getActiveAccount()?.username.toLowerCase());
    const [isSGICanadaUser, setIsSGICanadaUser] = useState(false);
    const [operatingLocation, setOperatingLocationInternal] = useState(JSON.parse(localStorage.getItem('selectedIssuerLocation')));
    const localAccountId = useState(runtime.getSession().getActiveAccount()?.localAccountId); // localAccountId === subId in the jwt claims
    const setOperatingLocation = useCallback((operatingLocationToSet) => {
        setOperatingLocationInternal(operatingLocationToSet);
        localStorage.setItem('selectedIssuerLocation', JSON.stringify(operatingLocationToSet));
    }, []);
    useEffect(() => {
        if (operatingLocation) {
            setAuthorizationScopeId(operatingLocation);
        }
    }, [operatingLocation, setAuthorizationScopeId]);
    // TODO:  delete this effect once we have a proper way to determine if a user is SGICanada.  For R1, in production, all customers will
    // be considered to have SGI Canada access.  The oids listed below belong to test accounts for DRIVE customers in the NPD B2C tenant.
    // This has to be set in the shell as opposed to remotes because some layout logic relies on it which doesn't get set if the customer
    // refreshes while in the SGI Canada remote.
    //
    // This will probably be replaced by an API call to seed some basic info about the Customer to be shared to the remotes via context.
    useEffect(() => {
        const subId = localAccountId[0]; // subId === oid in the jwt token claims
        const driveCustomerOids = [
            '49642017-b7e2-4b95-88ca-15470d588dbc',
            '31490a17-dc89-45a0-b417-b87461f0e2d6',
            'b6a3f0fa-be9e-4578-954f-3ed6bd180755',
            '30ce0f40-859e-44be-8e63-04cc2f179f07',
            '419370c5-e90e-42c2-9487-09c9ecf8c60e',
            'fc232269-2e11-4f68-bd8a-7943ccdf705b',
            '31468a33-4df3-4ded-a817-0636f3900693',
            'd03c7d1a-fa24-4b2f-a467-768ffd04c3f0',
            'b0a1a19b-3a56-473d-8be9-7b3b3dce102d',
            '81da3ffc-a69e-4b39-96c8-a0af80f01d7c',
            '3ac1cfaa-f7cf-4dac-9201-f919af3e7022',
            '0532c399-4218-46f0-b86e-0273b6e07284',
            '3c69a511-94a3-4f8a-848e-ebc5c15de2a8',
            'a049f095-b503-43d4-92ed-7b44d54a2571',
            'b6800b74-07c7-4300-b522-4cab81de2b00',
            '6e2857f1-7ca2-4faf-818c-796777225e84',
            '25ad8986-c714-44f8-bc4e-5b187edf33f6',
            'a2f3b818-beb7-4ef9-bde3-4c80c2f68029',
            'ddd6b91a-e936-44ff-9bfb-ab43ec6bda03',
            'b45aad7b-6d5b-4eed-96c0-ee27c99bc1ec',
            '91dbdccd-e813-498f-a4c1-89eb05be7126',
            '0ee1b085-30fc-4fe3-a3a9-038266d5ef23',
            '7fe80c13-900d-4a2e-babd-ebf5883b1058',
            '83645695-12bd-4fac-8d7b-44de2692bc43',
            '57224de4-9c35-459f-86e6-0c63b0836cc8',
            '5c05e828-96e8-4309-a183-32b56c00278f',
            '110ed514-1354-4623-8a4d-c57ca558dbac',
            '07a7d152-fdc1-452e-b7e9-197cc21d877d',
            '6b2eeb25-b4f8-4da2-8f69-3cd347aa0d49',
            '366962f6-b273-4067-8569-7ce3cb70627d',
            'ba73cce5-7d2e-44f6-9973-a8fe0262056e',
            '82d0f8b7-2e40-4668-ae2b-63d62af41628',
            '8f5fb041-8792-4dcd-a0e2-5ffaeceb1fa5',
            '903504a5-de71-491a-a237-71efc83cf023',
            '2822b75d-3743-4340-84e2-3bfcabd01d05',
        ];
        setIsSGICanadaUser(!driveCustomerOids.includes(subId));
    }, [localAccountId, setIsSGICanadaUser]);
    return (_jsx(UserContext.Provider, { value: { username, setUsername, operatingLocation, setOperatingLocation, isSGICanadaUser, setIsSGICanadaUser }, children: children }));
}
